import React, { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { importMintMappedBudget } from 'loot-core/client/actions';
import defaultCategoryGroups from 'loot-core/shared/category-groups';

import { OnboardingMintMappingContext } from '../../../../context/onboarding/OnboardingMintMappingContext';
import { View } from '../../../common/View';

import { OnboardingMintAccounts } from './OnboardingMintAccounts';
import { OnboardingMintCategories } from './OnboardingMintCategories';

type OnboardingMintMappingProps = {};

export function OnboardingMintMapping({}: OnboardingMintMappingProps) {
  const dispatch = useDispatch();
  const { state: routerState } = useLocation();
  const [importing, setImporting] = useState<boolean>(false);
  const [state, setState] = useState<'accounts' | 'categories'>('accounts');
  const { accountSet, categorySet } = useMemo(() => {
    let accountSet = [];
    let categorySet = [];
    //find all the needed info before importing
    for (let i = 0; i < routerState?.length; i++) {
      accountSet.push(routerState[i].AccountName);
      categorySet.push(routerState[i].Category);
    }

    // remove duplicates
    accountSet = [...new Set(accountSet)];
    categorySet = [...new Set(categorySet)];

    return {
      accountSet,
      categorySet,
    };
  }, []);

  const [accounts, setAccounts] = useState<
    { name: string; forBudget: boolean }[]
  >(() => {
    return accountSet.map(acc => ({
      name: acc,
      forBudget: false,
    }));
  });

  const [categoryGroups, setCategoryGroups] = useState(
    defaultCategoryGroups.map(cg => ({
      name: cg.name,
      categories: [],
    })),
  );

  return (
    <OnboardingMintMappingContext.Provider
      value={{
        accounts,
        setAccounts,
        categoryGroups,
        setCategoryGroups,
        accountSet,
        categorySet,
        importing,
      }}
    >
      <View style={{ backgroundColor: 'white', padding: 15 }}>
        {getContentByState()}
      </View>
    </OnboardingMintMappingContext.Provider>
  );

  function getContentByState() {
    switch (state) {
      case 'accounts':
        return (
          <OnboardingMintAccounts
            onNext={() => {
              setState('categories');
            }}
          />
        );
      case 'categories':
        return (
          <OnboardingMintCategories
            onBack={() => {
              setState('accounts');
            }}
            onImport={onImport}
          />
        );
    }
  }

  async function onImport(groupedCategoriesData) {
    setImporting(true);
    dispatch(
      importMintMappedBudget({
        accounts,
        groupedCategoriesData,
        json: routerState,
      }),
    );
  }
}
